/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioGrupoActividadEconomicaVistaProps } from '../interfaces';

const FormularioGrupoActividadEconomicaVista: React.FunctionComponent<IFormularioGrupoActividadEconomicaVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    grupoActividadEconomica,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'grupoActividadEconomica.agregarGrupoActividadEconomica'
                                : tipoFormulario === TipoFormulario.Edicion
                                ? 'grupoActividadEconomica.modificarGrupoActividadEconomica'
                                : 'grupoActividadEconomica.verGrupoActividadEconomica'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="grupoActividadEconomica.codigoGrupoActividadEconomica" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="CodigoGrupoActividadEconomica"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={grupoActividadEconomica.CodigoGrupoActividadEconomica}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="grupoActividadEconomica.nombreGrupoActividadEconomica" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="NombreGrupoActividadEconomica"
                        onChange={cambiarInfoFomulario}
                        required
                        value={grupoActividadEconomica.NombreGrupoActividadEconomica}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={grupoActividadEconomica.EstadoGrupoActividadEconomica}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="grupoActividadEconomica.estadoGrupoActividadEconomica" display="inline" />}
                        name="EstadoGrupoActividadEconomica"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained">
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioGrupoActividadEconomicaVista;
